
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { NavigateFunction, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

import { Box, Typography } from "@mui/material";
import NavigateListCustom from "../../../../components/navigation/NavigationListCustom";
import { routeName } from "../../../../routes/routeName";
import StepperCustom from "../../../../components/step/Stepper";
import { useTranslation } from "react-i18next";
import MeetingDetail from "./step/meeting-detail";
import MeetingCoordinator from "./step/meeting-coordinator";
import MeetingParticipants from "./step/meeting-participants";
import AgendaInformation from "./step/agenda-information";
import { ButtonBack, ButtonOutlined, ButtonPrimary } from "../../../../components/button/ButtonCustoms";
import { MeetingRoomApi } from "../../../../api/meeting-room/meeting-room.api";
import { alertError, swalError, swalSuccess } from "../../../../components/alert/swal";
import { dateToView, timeToView } from "../../../../utils/date.utils";
import Resolution from "./step/resolution";
import moment from "moment";
import InfoIcon from '@mui/icons-material/Info';
import OptionsButtonCustom from "../../../../components/option-button/OptionsButtonCustom";
import TableRowCommon from "../../../../components/table/TableRowCommon";
import { setLoading, unsetLoading } from "../../../../store/loading/loading.slice";
import TableCustom from "../../../../components/table/tableCustom";
import { MeetingExampleFileApi } from "../../../../api/manage-sample-files/manage-sample-files.api";
import ModalCustom from "../../../../components/modal/ModalCustom";
import ConductMeeting from "./step/conduct-meeting";
type Props = {};

const MeetingCalendarDetail: React.FC<Props> = (props: Props) => {
    const { id } = useParams();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const id_complaints = searchParams.get("id_complaints");
    const mode = searchParams.get("mode");
    const navigate: NavigateFunction = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [open, setOpen] = useState<boolean>(false);

    const params = new URLSearchParams(location.search);
    const meetingRoomName = params.get("meeting_room_name");
    const meetingRoomDesc = params.get("meeting_room_desc");

    const defaultStateFormMeetingRoom = {
        id_meeting_type: 0,
        meeting_room_name: meetingRoomName || undefined,
        meeting_room_desc: meetingRoomDesc || undefined,
        meeting_room_password: undefined,
        meeting_room_start_date: moment().format('YYYY-MM-DD'),
        meeting_room_end_date: moment().format('YYYY-MM-DD'),
        meeting_room_location: undefined,
        meeting_room_link: undefined,
        id_meeting_file_contents: undefined,
        id_meeting_file_agenda: undefined,
        id_meeting_file_other: undefined,
    }
    const [formMeetingRoom, setFormMeetingRoom] = useState<any>(defaultStateFormMeetingRoom)
    // const step: number = useSelector((state: any) => state?.step?.step);
    const [step, setStep] = useState<number>(0)
    const [notEdit, set์otEdit] = useState<boolean>(true)
    const allStep: any[] = useMemo(() => [
        { name: t('MEETING_CATEGORY.DETAILS'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_COORDINATOR'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_PARTICIPANTS'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.AGENDA_INFO'), isAccept: true, icon: null, disabled: !notEdit },
        // { name: t('MEETING.MEETING_RESOLUTIONS'), isAccept: true, icon: null, disabled: !notEdit },

    ], [t,]);
    const allStepView: any[] = useMemo(() => [
        { name: t('MEETING_CATEGORY.DETAILS'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_COORDINATOR'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_PARTICIPANTS'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.AGENDA_INFO'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('ดำเนินการประชุม'), isAccept: true, icon: null, disabled: !notEdit },
        { name: t('MEETING.MEETING_RESOLUTIONS'), isAccept: true, icon: null, disabled: !notEdit },

    ], [t,]);

    // console.log(formMeetingRoom);

    const getDetail = async () => {
        await MeetingRoomApi.findById(id).then((res: any) => {
            if (res.status < 300) {
                console.log(res.data.data);
                setFormMeetingRoom({
                    ...formMeetingRoom, ...res.data.data,
                    meeting_room_start_date: res.data.data.meeting_room_end_date ? moment(res.data.data.meeting_room_start_date).format('YYYY-MM-DD') : '',
                    meeting_room_end_date: res.data.data.meeting_room_end_date ? moment(res.data.data.meeting_room_end_date).format('YYYY-MM-DD') : '',
                    meeting_room_start_time: timeToView(res.data.data?.meeting_room_start_date),
                    meeting_room_end_time: timeToView(res.data.data?.meeting_room_end_date),
                    // meeting_room_password: undefined, meeting_room_password_check: undefined
                    meeting_room_password_check: res.data.data?.meeting_room_password
                })
                // loadData()
                // handleClose()
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }
    console.log(formMeetingRoom);
    useEffect(() => {
        if (id) {
            getDetail()
        }

    }, [])
    const handleSubmitMeetingRoom = async (meeting_room_status?: any) => {
        if (!formMeetingRoom?.id_meeting_type) {
            return alertError('ระบุประเภท')
        }
        if (!formMeetingRoom?.meeting_room_name) {
            return alertError('ระบุชื่อ')
        }
        if (!formMeetingRoom?.meeting_room_start_date) {
            return alertError('ระบุวันที่ประชุม')
        }
        if (!formMeetingRoom?.meeting_room_start_time) {
            return alertError('ระบุเวลาเริ่มต้น')
        }
        if (!formMeetingRoom?.meeting_room_end_time) {
            return alertError('ระบุเวลาสิ้นสุด')
        }
        const body = {
            id_meeting_type: formMeetingRoom?.id_meeting_type,
            meeting_room_name: formMeetingRoom?.meeting_room_name,
            meeting_room_desc: formMeetingRoom?.meeting_room_desc,
            meeting_room_password: formMeetingRoom?.meeting_room_password,
            meeting_room_start_date: `${formMeetingRoom?.meeting_room_start_date}T${formMeetingRoom?.meeting_room_start_time}`,
            meeting_room_end_date: `${formMeetingRoom?.meeting_room_end_date}T${formMeetingRoom?.meeting_room_end_time}`,
            meeting_room_location: formMeetingRoom?.meeting_room_location,
            meeting_room_link: formMeetingRoom?.meeting_room_link,
            meeting_room_status: meeting_room_status,
            id_meeting_file_contents: formMeetingRoom?.meeting_file_contents?.filter((item: any) => item?.id_meeting_room_file)?.map((item: any) => item?.id_meeting_room_file) || undefined,
            id_meeting_file_agenda: formMeetingRoom?.meeting_file_agenda?.filter((item: any) => item?.id_meeting_room_file)?.map((item: any) => item?.id_meeting_room_file) || undefined,
            id_meeting_file_other: formMeetingRoom?.meeting_file_other?.filter((item: any) => item?.id_meeting_room_file)?.map((item: any) => item?.id_meeting_room_file) || undefined,
            ...(id_complaints && {
                id_complaints: +id_complaints
            })
        }

        if (id) {
            await MeetingRoomApi.patch(body, id).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MEETING.MEETING_MINUTES_RECORDED'))
                    navigate(routeName.cms.MeetingCaledarDetail.replace(':id', id))
                    // loadData()
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })
        } else {
            await MeetingRoomApi.post(body).then((res: any) => {
                if (res.status < 300) {
                    swalSuccess(t('MEETING.ADD_MEETING_SUCCESS'))
                    navigate(routeName.cms.MeetingCaledarDetail.replace(':id', res?.data?.data?.id_meeting_room))
                    // loadData()
                    // handleClose()
                }
            }).catch((error: any) => {
                console.log(error)
                swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
            })
        }



    }

    return (
        <div className="h-auto">
            {/* breadcrumbs */}
            <NavigateListCustom
                navigateData={[
                    {
                        name: t("MEETING.MEETING_CALENDAR"),
                        key: "1",
                        pathName: routeName.cms.MeetingCalendar,
                    },
                    {
                        name: mode ? 'ข้อมูลการประชุม' : t("MEETING.ADD_MEETING"),
                        key: "2",
                        pathName: routeName.cms.MeetingCaledarCreate,
                    },
                ]}
            />

            {/* header */}
            <section className="my-4">
                <Typography variant="h3">{(mode || id) ? 'ข้อมูลการประชุม' : t('MEETING.ADD_MEETING')}</Typography>
            </section>
            {mode && <Box sx={{ margin: '10px 0px', display: 'flex', gap: '10px', cursor: 'pointer' }} onClick={() => setOpen(true)}>
                <InfoIcon sx={{ color: '#828282' }} />
                <Typography>ข้อมูลไฟล์ตัวอย่าง</Typography>
            </Box>}
            <section className='w-full' style={{ display: mode ? 'flex' : 'block', justifyContent: mode ? 'center' : 'inherit' }}>
                <StepperCustom
                    sx={{ maxWidth: "1000px" }}
                    step={step}
                    setStep={(num: number) => {
                        // dispatch(setStep(num));
                        if (!formMeetingRoom?.id_meeting_type) {
                            return alertError('ระบุประเภท')
                        }
                        if (!formMeetingRoom?.meeting_room_name) {
                            return alertError('ระบุชื่อ')
                        }
                        if (!formMeetingRoom?.meeting_room_start_date) {
                            return alertError('ระบุวันที่ประชุม')
                        }
                        if (!formMeetingRoom?.meeting_room_start_time) {
                            return alertError('ระบุเวลาเริ่มต้น')
                        }
                        if (!formMeetingRoom?.meeting_room_end_time) {
                            return alertError('ระบุเวลาสิ้นสุด')
                        }
                        if (id) {
                            setStep(num)
                        }
                    }}
                    stepLabel={mode ? allStepView : allStep}
                    view={mode ? true : false}
                />
            </section>
            {step === 0 &&
                <section className="w-full mt-10">

                    <MeetingDetail formMeetingRoom={formMeetingRoom} setFormMeetingRoom={setFormMeetingRoom} />
                </section>
            }
            {step === 1 &&
                <MeetingCoordinator />
            }
            {step === 2 &&
                <MeetingParticipants />
            }
            {step === 3 &&
                <AgendaInformation />
            }
            {step === 4 &&
                <ConductMeeting/>
            }
            {step === 5 &&
                <Resolution />
            }
            {step !== 5 &&
            <section className="col-span-12 flex items-center justify-center gap-4 my-4">
                <ButtonOutlined
                    onClick={() => {
                        navigate(routeName.cms.MeetingCalendar);
                    }}
                    buttonName="ย้อนกลับ"
                    btnProps={{
                        width: "150px",
                    }}
                />

                {step === 0 && <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        handleSubmitMeetingRoom('DRAFT')
                    }}
                    mode="save"
                    buttonName="บันทึกร่าง"
                    btnProps={{
                        width: "150px",
                    }}
                />}
                {!mode && step === 3 ? <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);NOT_START_YET
                        handleSubmitMeetingRoom('NOT_START_YET')
                    }}
                    mode="success"
                    buttonName="ยืนยัน"
                    btnProps={{
                        width: "150px",
                    }}
                />  : <ButtonPrimary
                    onClick={() => {
                        // handleSubmit(inputValueFormStudent.information);
                        // handleSubmitMeetingRoom('DRAFT')
                        if (!formMeetingRoom?.id_meeting_type) {
                            return alertError('ระบุประเภท')
                        }
                        if (!formMeetingRoom?.meeting_room_name) {
                            return alertError('ระบุชื่อ')
                        }
                        if (!formMeetingRoom?.meeting_room_start_date) {
                            return alertError('ระบุวันที่ประชุม')
                        }
                        if (!formMeetingRoom?.meeting_room_start_time) {
                            return alertError('ระบุเวลาเริ่มต้น')
                        }
                        if (!formMeetingRoom?.meeting_room_end_time) {
                            return alertError('ระบุเวลาสิ้นสุด')
                        }
                        if (id) {
                            setStep(step + 1)
                        } else {
                            handleSubmitMeetingRoom('DRAFT')
                        }

                    }}
                    mode="next"
                    buttonName="ถัดไป"
                    btnProps={{
                        width: "150px",
                    }}
                />}
               
            </section>}
            <ModalCustom maxWidth={800} title={t('ข้อมูลไฟล์ตัวอย่าง')} subTitle='' open={open} component={
                <div className='flex flex-col gap-4'>
                    <SampleFiles />

                    <div className='flex justify-center gap-4'>
                        <ButtonBack
                            onClick={() => {
                                setOpen(false)
                            }}
                            buttonName={'ยกเลิก'}
                        />

                    </div>
                </div>
            } />
        </div>
    );
};

export default MeetingCalendarDetail;


function SampleFiles() {

    const dispatch = useDispatch();
    const { t } = useTranslation();

    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [status, setStatus] = useState<string>("active");
    const [sortType, setSortType] = useState<string>("ASC");

    const [sortBy, setSortBy] = useState<string>("");
    const [pathUrl, setPathUrl] = useState<string>("");
    useEffect(() => {
        const init = async () => {
            const response = await fetch("/resources/config.json");
            const results = await response.json();
            setPathUrl(results?.REACT_APP_BASE_API_PUBLIC || "");
        };
        init();
    }, []);
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy);
        setSortType(sortType);
    };
    const getDownload = async (id_meeting_room_file: number) => {
        await MeetingExampleFileApi.findById(id_meeting_room_file).then(async (res: any) => {
            if (res.status < 300) {
                window.open(pathUrl + '/' + res.data.data?.file_path + res.data.data?.file_name, '_blank')
                // const response = await fetch(pathUrl + '/' + res.data.data?.file_path + res.data.data?.file_name);
                // const blob = await response.blob();

                // const blobUrl = window.URL.createObjectURL(blob);
                // const a = document.createElement("a");
                // a.href = blobUrl;
                // a.download = res.data.data?.file_name || pathUrl + '/' + res.data.data?.file_path + res.data.data?.file_name.split("/").pop();
                // document.body.appendChild(a);
                // a.click();

                // // ล้าง blob URL
                // a.remove();
                // window.URL.revokeObjectURL(blobUrl);
            }
        }).catch((error: any) => {
            console.log(error)
            swalError(error?.response?.data?.message || 'เกิดข้อผิดพลาด')
        })
    }
    function formatBytes(bytes: any, decimals = 2) {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    }
    const headCells = [
        {
            id: "#",
            width: '400px',
            sortable: false,
            disablePadding: false,
            align: "start",
            label: "file",
        },

        {
            id: "action",
            disablePadding: false,
            align: "center",
            width: '100px',
            label: "",
        },
    ];

    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1;
        const { display_name, id_meeting_room_file, modified_date, file_size } =
            objData;

        const objRenderData = {
            key: id_meeting_room_file,
            id: no,
            obj: objData,
            columns: [
                {
                    option: "TEXT",
                    align: "start",
                    label: `${display_name}  ${formatBytes(file_size)} ${dateToView(modified_date)}` || "-",
                },


                {
                    option: "TEXT",
                    align: "center",
                    label: (
                        <OptionsButtonCustom
                            enableView

                            onViewClick={() => {
                                // navigate(routeName.students.MeetingCaledarDetail.replace(':id', id_meeting_room))
                                getDownload(id_meeting_room_file)
                            }}
                        />
                    ),
                },
            ],
        };
        return <TableRowCommon {...objRenderData} />;
    };

    const loadData = useCallback(async () => {
        dispatch(setLoading());

        try {
            let condition: any = {};
            if (page) condition = { ...condition, page: page };
            if (pageLimit) condition = { ...condition, limit: pageLimit };

            if (status !== 'ALL') condition = { ...condition, status: status };

            const res = await MeetingExampleFileApi.list(condition);
            const data = res.data
            if (data?.status < 300) {
                setData(data?.data.items);
                setPage(data?.data?.meta.currentPage)
                setTotalItems(data?.data?.meta?.totalItems)
                dispatch(unsetLoading());
            } else {
                dispatch(unsetLoading());
            }
        } catch (error) {
            dispatch(unsetLoading());
        }
    }, [page, pageLimit, status]);

    useEffect(() => {
        loadData();
    }, [loadData]);
    return (
        <div>
            <section className="w-full mt-10">
                <TableCustom
                    // tableMinWidth={1440}
                    tableFixedWidth
                    customScroll
                    page={page}
                    pageLimit={pageLimit}
                    sortBy={sortBy}
                    sortType={sortType}
                    headCells={headCells}
                    rowCount={totalItems}
                    rowsData={
                        data.map((data: any, i: any) => {
                            return renderData(data, i);
                        })
                    }
                    onSort={handleRequestSort}
                    setPageLimit={(value: number) => setPageLimit(value)}
                    setPage={(value: number) => setPage(value)}
                />
            </section>
        </div>
    )
}
